// Il marchio di PopTown (tela Claude Design, artboard 54 e 55): il logo di peluche dove c'è
// spazio (login, aggiornamento), le tre casette dove non c'è (header, menu chiuso, icone) e il
// nome scritto con il font della plancia, una lettera per colore: sotto i 32 px il peluche non
// si legge.

export function PopTownLogo({ height = 96 }: { height?: number }) {
  // altezza e larghezza automatiche con due massimi: in una card più stretta del logo si
  // rimpicciolisce intero, senza schiacciarsi (prima l'altezza era fissa)
  return (
    <img
      src="/poptown-logo.webp"
      alt="PopTown"
      style={{
        display: 'block',
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: height,
        objectFit: 'contain',
        flex: 'none',
      }}
    />
  );
}

export function PopTownMark({ size = 24, title }: { size?: number; title?: string }) {
  return (
    <img
      src="/poptown-mark.webp"
      alt={title ?? ''}
      aria-hidden={title ? undefined : true}
      width={size}
      height={size}
      style={{ display: 'block', width: size, height: size, flex: 'none' }}
    />
  );
}

// i colori delle lettere del logo, dai token delle sessioni (leggibili nei due temi)
const LETTERS: [string, string][] = [
  ['P', 'var(--ses-1)'],
  ['o', 'var(--ses-5)'],
  ['p', 'var(--ses-2)'],
  ['T', 'var(--ses-4)'],
  ['o', 'var(--ses-6)'],
  ['w', 'var(--ses-3)'],
  ['n', 'var(--ses-1)'],
];

export function PopTownName({ size = 20 }: { size?: number }) {
  return (
    <span
      aria-label="PopTown"
      className="poptown-name"
      style={{ font: `800 ${size}px/1.2 var(--font-ui)`, letterSpacing: '-0.01em', flex: 'none' }}
    >
      {LETTERS.map(([ch, color], i) => (
        <span key={i} aria-hidden="true" style={{ color }}>
          {ch}
        </span>
      ))}
    </span>
  );
}
